let brainInstanceInject = function (graph) {
    // 注入对象 不用箭头函数可以直接使用this this即graph
    let injectObj = {
        dataProcess(data = this.data) {
            data.nodes.sort((a, b) => b.depth - a.depth); // 大的在前面 后来就排到后面
            data.nodes.forEach((d) => {
                d.isleaf === '0' ? d.isLeaf = false : d.isLeaf = true;  // 喜欢布尔值
                if (d.depth === '0' && d.clusterId === 0) {
                    d.fx = this.width / 2 + 50;
                    d.fy = this.height / 2;
                }
                if ($qsObj && $qsObj.forcedebug === 'true') {
                    d.name = d.depth + d.name;
                }
            });

        },
        async lightStep(lightTime = 1000, isForce) {
            for (let i = 0; i < 4; i++) {
                if (this.isStop && isForce === false) { return void 0; }
                if (this.isDestroy && isForce === false) { return void 0; }
                this.nodesGroup.filter(`.node-depth-${i}`).classed('kg-force-node-wrap-opacity', false);
                this.linksGroup.filter(`.link-depth-${i}`).classed('kg-force-link-opacity', false);
                await this.$sleep(lightTime);
            }
        },
        async darkStep(darkTime = 0) {
            for (let i = 0; i < 4; i++) {
                if (this.isStop) { return void 0; }
                if (this.isDestroy === true) { return void 0; }
                this.nodesGroup.filter(`.node-depth-${i}`).classed('kg-force-node-wrap-full', false).classed('kg-force-node-wrap-opacity', true);
                this.linksGroup.filter(`.link-depth-${i}`).classed('kg-force-link-full', false).classed('kg-force-link-opacity', true);
                await this.$sleep(darkTime);
            }
        },

    };
    graph.inject(injectObj);
};

export default brainInstanceInject;
